import { useDispatch, useSelector } from 'react-redux'

import { setSettingsAction } from '@/bus/ui/actions'
import { IRootState } from '@/store/reducer'

export const useUi = () => {
  const dispatch = useDispatch()

  const { settings } = useSelector(({ ui }: IRootState) => ui)

  const setSettings = (props: any) => dispatch(setSettingsAction(props))

  return {
    settings,
    setSettings
  }
}
